<template>
    <div class="feature-list__one">
        <div class="row">
            <div v-for="(item, x) in items" :key="x" class="col-lg-6 wow move-up">
                <div class="grid-item animate">
                    <div class="ht-box-icon style-01">
                        <div class="icon-box-wrap">
                            <div class="image">
                                <img :src="item.icon" class="img-fluid" alt="aeroland-app-showcase-box-icon-image-01">
                            </div>
                            <div class="content">
                                <h6 class="heading">{{ item.heading }}</h6>
                                <div class="text">{{ item.text }}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'FeatureApp',
        data (){
            return {
                items: [
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-01.png'), 
                        heading: 'Built for Physicians', 
                        text: 'Managemed was built with physicians\' aid to manage an organization better while keeping treatment quality standards.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-02.png'), 
                        heading: 'Integrated Patient Cases', 
                        text: 'All data related to a medical record and patient case is linked so that inventories, bills and treatment are all consistent with one another.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-03.png'), 
                        heading: 'Secure and Consistent Patient Data', 
                        text: 'Keep medical records, and patient bills securely stored in the cloud for greater consistency, accessibility, and reliability.'
                    },
                    {
                        icon: require('../assets/img/icons/aeroland-app-showcase-box-icon-image-04.png'), 
                        heading: 'Manage & Get Organized with Ease', 
                        text: 'Manage physicians and staff and inventories to keep patients\' treatment to the utmost quality for medical excellence.'
                    },
                ]
            }
        }
    }
</script>
